import React, {useState, useEffect,useMemo} from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {InputGeneral}                       from "components/Field/field";
import Style                                from "components/UI/main.module.scss";
import  {   //  Development Stage
            getDevelopmentStageList,        
            getDevelopmentStageByID,
            updateDevelopmentStage,
            updateDevelopmentStageStatus,
            deleteDevelopmentStage, 
            //  Application Content
            getApplicationContentList,        
            getApplicationContentByID,
            updateApplicationContent,
            updateApplicationContentStatus,
            deleteApplicationContent,                        
        }                                   from "./contentService";
import  {   q3x_FunData, 
            q3z_IFunNumbers,
            GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            SpinnerSmall,
            ValidateBusinessRules,
        }                                   from "Utilities/utils";    
import  {
            DisplayGridDatetime
        }                                   from "components/Date/date";
import { useNavigate }                      from "react-router-dom";
import { useModal }                         from "components/Covers/genericModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { useSideContent }                   from "components/SideContent/sideContent";
import {ModalContentGoAction, ModalContent} from "components/Modal/modal";
import {TableGrid}                          from "components/Table/table";
import {SearchableDropdownList}             from "components/DropdownListField/dropdownListFIeld";
import {ContentEditor}                      from "components/ContentEditor/contentEditor"; 
import  {   StatusFilter}                   from "components/Filter/statusFilter";
import  {   NeedSaveBlock}                  from "components/Validation/needSaveBlock";
import  {   useEditDraftAutoSave,
            takeEditDraft,
            clearEditDraft,
        }                                   from "Utilities/editDraft";
import  {   getSystemStatusList}            from "Services/service";
import { AccessDeniedContent } from "components/Content/accessContent";

let blank_development_stage_obj     = {
    NeedSave: false,
    DevelopmentStageId: 0,
    StatusId: 1,
    DevelopmentStageNamePt: "",
    DevelopmentStageNameEn: "",
    DevelopmentStageNameEs: "",
    DevelopmentStageDescPt: "",
    DevelopmentStageDescEn: "",
    DevelopmentStageDescEs: "",
};
let blank_app_content_obj           = {
    NeedSave: false,
    AppContentId: 0,
    AppContentType: 1,
    AppContentOrder: 0,
    StatusId: 1,
    AppContentNamePt: "",
    AppContentNameEn: "",
    AppContentNameEs: "",
    AppContentDataPt: "",
    AppContentDataEn: "",
    AppContentDataEs: "",
};

const formatMessages            = ({messageHeader, messageVector}) => {
    return (
        <React.Fragment>
            <div>
                <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                    {messageHeader}
                </span>
            </div>
            <div>
                {messageVector.map((msg, i) => (
                    <React.Fragment key={i}>
                        <div className={Style.my_3}>
                            <span className={[Style.text_body, Style.fs_8, Style.my_3,].join(" ")}>
                                {i + 1} : {msg}<br/>
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    );
}; 
//#region   Application Content         
const AppContentEditBtn       = React.memo((props) => {
    const { 
        StatusList,
        setIsLoading,
        fetchAppContentList,
    }                                   = props.context;
    const { data }                      = props;
    const { showSideContent }           = useSideContent();    
    const { showModal       }           = useModal();

    const fetchApplicationContentData     = async (itemId) => {
        try {
            let payload = await getApplicationContentByID({ AppContentId: itemId });
            if (payload?.Status?.Code === 0) {
                return payload.Response.Content;
            } 
            else {
                showModal(<ModalContent Message={payload?.Status?.Message || "Error"} />);
                return null;
            }
        } 
        catch (error) {
            return null;
        }
    };
    const handleEditClick               = async () => {
        const canEdit = (StatusList?.length > 0);
        if (canEdit) {
            setIsLoading(true);
            const obj = await fetchApplicationContentData(data.AppContentId);
            if (obj) {
                showSideContent({
                    component: AppContentEdit,
                    props: {
                        StatusList: StatusList,
                        fetchAppContentList: fetchAppContentList, 
                        ApplicationContentData: obj,
                    },
                    overlay: true,
                });
            }
            setIsLoading(false);
        }
    };

    return(
        <div onClick={handleEditClick} className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"className={[Style.small_ico_generic].join(" ")}>
                <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
            </svg>
        </div>
    );    
});
const AppContentEdit          = React.memo(({...setProps}) => {
    const {
        StatusList,
        fetchAppContentList,
        ApplicationContentData,
    }                                                           = setProps;
    const [ isLoading,           setIsLoading]                  = useState(true);
    const [ appContentObj, setAppContentObj]                    = useState(null);
    const { showToastMessage}                                   = useToastMessage();
    const { showSideContent,    hideSideContent}                = useSideContent();
    const { showModal,          hideModal}                      = useModal();
    const draftKey                                               = `AppContentEdit-${ApplicationContentData?.AppContentId ?? 0}`;

    useEditDraftAutoSave({
        draftKey,
        data:     appContentObj,
        needSave: appContentObj?.NeedSave,
    });

    const handleSave        = async ()  => {
        setIsLoading(true);
        let payload = await updateApplicationContent(appContentObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                setAppContentObj(prev => ({
                    ...prev,
                    NeedSave: false,
                    AppContentId: payload.Response.Content.AppContentId,
                }));
                clearEditDraft();
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction        = async ()  => {
        let messages = [];
        if (appContentObj?.AppContentNamePt?.length === 0   || appContentObj?.AppContentNamePt === null || appContentObj?.AppContentNamePt === undefined) {
            messages.push(GetSystemLabel("WarningFillMandatoryData"));
        }
        if (appContentObj?.AppContentDataPt?.length === 0   || appContentObj?.AppContentDataPt === null || appContentObj?.AppContentDataPt === undefined) {
            messages.push(GetSystemLabel("WarningFillMandatoryData"));
        }
        if (appContentObj?.StatusId === 0   || appContentObj?.StatusId === null || appContentObj?.StatusId === undefined) {
            messages.push(GetSystemLabel("WarningFillStatusData"));
        }
        if (appContentObj?.AppContentOrder === null || appContentObj?.AppContentOrder === undefined) {
            messages.push(GetSystemLabel("WarningFillMandatoryData"));
        }        
        if (messages.length > 0) {
            showModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await fetchAppContentList();
        }
    };
    const handleDelete      = async ()  => {
        setIsLoading(true);
        let payload = await deleteApplicationContent(appContentObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction      = async ()  => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {                
                    hideModal();
                    await handleDelete();
                    await fetchAppContentList();
                    await hideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp         = appContentObj;
        tmp.StatusId    = (tmp.StatusId === 1) ? 2 : 1;
        let payload     = await updateApplicationContentStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setAppContentObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await hideModal();
                    await handleStatus();
                    await fetchAppContentList();
                }}
            />
        );
    };       

    useEffect(() => {
        if (ApplicationContentData) {
            const obj = ApplicationContentData;
            const draft = takeEditDraft(`AppContentEdit-${obj?.AppContentId ?? 0}`);
            setAppContentObj(prev => {
                return({
                    ...prev,
                    ...obj,
                    ...(draft ?? {}),
                });
            });
        }
        else {
            const draft = takeEditDraft(`AppContentEdit-${blank_app_content_obj?.AppContentId ?? 0}`);
            setAppContentObj({...blank_app_content_obj, ...(draft ?? {})});
        }
        setIsLoading(false);
    }, [ApplicationContentData, StatusList]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={appContentObj?.NeedSave}/>
                    {/* Name Portuguese*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Portuguese")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={appContentObj?.AppContentNamePt}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setAppContentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AppContentNamePt : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{appContentObj?.DevelopmentStageNamePt?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* Name English*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("English")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={appContentObj?.AppContentNameEn}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setAppContentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AppContentNameEn : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{appContentObj?.DevelopmentStageNameEn?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* Name Spanish*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Spanish")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={appContentObj?.AppContentNameEs}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setAppContentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AppContentNameEs : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{appContentObj?.DevelopmentStageNameEs?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>                                        
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* Status Selection */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Status")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>                                
                            <SearchableDropdownList    
                                placeholder={GetSystemLabel("Status")}      
                                listOfItems={
                                    StatusList && Array.isArray(StatusList)
                                    ? 
                                        StatusList?.map((d) => ({ value: d.StatusId, label: d[`StatusName${GetAppLang()}`] }))
                                    : 
                                        null
                                }
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}
                                onChange={(event) => {
                                    setAppContentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            StatusId : event,
                                        });
                                    });
                                }}
                                value={appContentObj?.StatusId > 0 ? parseInt(appContentObj?.StatusId) : 1}
                            />
                        </div>
                    </div>     

                    <div className={[Style.py_2].join(" ")}/>

                    {/* Content Order */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("ContentOrder")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>                                
                            <InputGeneral 
                                defaultValue={1}
                                value={appContentObj?.AppContentOrder}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    const n = q3z_IFunNumbers(event.target.value);
                                    setAppContentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AppContentOrder : n === '' ? 0 : parseInt(n, 10),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Order")}
                                maxLength={10}
                            />
                        </div>
                    </div>

                    <div className={[Style.py_2].join(" ")}/>

                    {/* Content Portuguese*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Content")} {GetSystemLabel("Portuguese")}{"*"}
                            </span>
                        </div>
                    </div>  
                    <div className={[Style.py_2].join(" ")}/>
                    <ContentEditor 
                        value={appContentObj?.AppContentDataPt}
                        onChange={(event) => {
                            setAppContentObj(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    AppContentDataPt : event,
                                });
                            });
                        }}
                    />

                    <div className={[Style.py_2].join(" ")}/>

                    {/* Content English*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Content")} {GetSystemLabel("English")}
                            </span>
                        </div>
                    </div>
                    <div className={[Style.py_2].join(" ")}/>  
                    <ContentEditor 
                        value={appContentObj?.AppContentDataEn}
                        onChange={(event) => {
                            setAppContentObj(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    AppContentDataEn : event,
                                });
                            });
                        }}
                    />
                    
                    <div className={[Style.py_2].join(" ")}/>
                    
                    {/* Content Spanish*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Content")} {GetSystemLabel("Spanish")}
                            </span>
                        </div>
                    </div>  
                    <div className={[Style.py_2].join(" ")}/>
                    <ContentEditor 
                        value={appContentObj?.AppContentDataEs}
                        onChange={(event) => {
                            setAppContentObj(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    AppContentDataEs : event,
                                });
                            });
                        }}
                    />

                    <div className={[Style.py_5, Style.border_bottom].join(" ")}/>                            
                    
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((appContentObj?.AppContentId !== null) && (appContentObj.AppContentId !== undefined) && (appContentObj.AppContentId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {appContentObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>                          
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );
});
const AppContentContent       = React.memo(({...setProps}) => {
    const { ContentType, 
            StatusList,
            SearchStatus,
            SetSearchStatus,
    }               = setProps;
    // Mount State                
    const [isReady, setIsReady]                     = useState(false);     
    // Loading State                  
    const [ isLoading,  setIsLoading]               = useState(true);  
    const [rowData,     setRowData]                 = useState([]);   
    const [searchText,  setSearchText]              = useState('');
    const { showSideContent}                        = useSideContent();    
    const { showModal}                              = useModal();

    const fetchAppContentList = async () => {
        try {
            let payload = await getApplicationContentList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const gridContext               = useMemo(() => ({
        isLoading,
        StatusList,
        setIsLoading,
        fetchAppContentList: fetchAppContentList,
    }), [StatusList]);

    const columnDefs                = useMemo(() => [
        {
            headerName: GetBusinessLabel("TableHeaderContentFeedback"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("Edit"),                     field: GetSystemLabel("Edit")               ,cellRenderer: AppContentEditBtn, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                { hide: false,lockVisible: true,                          headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Portuguese")}`,             field: "AppContentNamePt"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("English")}`,                field: "AppContentNameEn"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Spanish")}`,              field: "AppContentNameEs"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: GetSystemLabel("Order"),                      field: "AppContentOrder"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },         
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "AppContentId"               ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                                
                { hide: false,lockVisible: true,columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
            ]
        },
    ].filter(Boolean), []);    

    const NewItem                   = () => {
        const obj_copy = JSON.parse(JSON.stringify(blank_app_content_obj));
        showSideContent({
            component: AppContentEdit,
            props: {
                StatusList: StatusList,
                fetchAppContentList: fetchAppContentList, 
                ApplicationContentData: obj_copy,
            },
            overlay: true,
        });        
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            fetchAppContentList();
        }
    }, [ContentType, isReady, StatusList]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("ContentPageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={fetchAppContentList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>                         
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                     
                        </div>
                    </div>                                  
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                gridContext={gridContext}
                            />                     
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
});
//#endregion
//#region   Development Stage           
const DevelopmentStageEditBtn       = React.memo((props) => {
    const { 
        setIsLoading,
        fetchDevelopmentStageList,
    }                                   = props.context;
    const { data }                      = props;
    const { showSideContent }           = useSideContent();    
    const { showModal       }           = useModal();

    const fetchDevelopmentStageData     = async (itemId) => {
        try {
            let payload = await getDevelopmentStageByID({ DevelopmentStageId: itemId });
            if (payload?.Status?.Code === 0) {
                return payload.Response.Content;
            } 
            else {
                showModal(<ModalContent Message={payload?.Status?.Message || "Error"} />);
                return null;
            }
        } 
        catch (error) {
            return null;
        }
    };
    const handleEditClick               = async () => {
        setIsLoading(true);
        const obj = await fetchDevelopmentStageData(data.DevelopmentStageId);
        if (obj) {
            showSideContent({
                component: DevelopmentStageEdit,
                props: {
                    fetchDevelopmentStageList: fetchDevelopmentStageList,
                    DevelopmentStageData: obj,
                },
                overlay: true,
            });
        }
        setIsLoading(false);
    };

    return(
        <div onClick={handleEditClick} className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"className={[Style.small_ico_generic].join(" ")}>
                <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
            </svg>
        </div>
    );    
});
const DevelopmentStageEdit          = React.memo(({...setProps}) => {
    const {
        fetchDevelopmentStageList,
        DevelopmentStageData,
    }                                                           = setProps;
    const [ isLoading,           setIsLoading]                  = useState(true);
    const [ developmentStageObj, setDevelopmentStageObj]        = useState(null);
    const { showToastMessage}                                   = useToastMessage();
    const { showSideContent,    hideSideContent}                = useSideContent();
    const { showModal,          hideModal}                      = useModal();
    const draftKey                                               = `DevelopmentStageEdit-${DevelopmentStageData?.DevelopmentStageId ?? 0}`;

    useEditDraftAutoSave({
        draftKey,
        data:     developmentStageObj,
        needSave: developmentStageObj?.NeedSave,
    });

    const handleSave        = async ()  => {
        setIsLoading(true);
        let payload = await updateDevelopmentStage(developmentStageObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                setDevelopmentStageObj(prev => ({
                    ...prev,
                    NeedSave: false,
                    DevelopmentStageId: payload.Response.Content.DevelopmentStageId,
                }));
                clearEditDraft();
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction        = async ()  => {
        let messages = [];
        if (developmentStageObj?.DevelopmentStageDescPt?.length === 0   || developmentStageObj?.DevelopmentStageDescPt === null || developmentStageObj?.DevelopmentStageDescPt === undefined) {
            messages.push(GetSystemLabel("WarningFillMandatoryData"));
        }
        if (developmentStageObj?.DevelopmentStageNamePt?.length === 0   || developmentStageObj?.DevelopmentStageNamePt === null || developmentStageObj?.DevelopmentStageNamePt === undefined) {
            messages.push(GetSystemLabel("WarningFillMandatoryData"));
        }
        if (messages.length > 0) {
            showModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await fetchDevelopmentStageList();
        }
    };
    const handleDelete      = async ()  => {
        setIsLoading(true);
        let payload = await deleteDevelopmentStage(developmentStageObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction      = async ()  => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {                
                    hideModal();
                    await handleDelete();
                    await fetchDevelopmentStageList();
                    await hideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp         = developmentStageObj;
        tmp.StatusId    = (tmp.StatusId === 1) ? 2 : 1;
        let payload     = await updateDevelopmentStageStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setDevelopmentStageObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await hideModal();
                    await handleStatus();
                    await fetchDevelopmentStageList();
                }}
            />
        );
    };    

    useEffect(() => {
        if (DevelopmentStageData) {
            const obj = DevelopmentStageData;
            const draft = takeEditDraft(`DevelopmentStageEdit-${obj?.DevelopmentStageId ?? 0}`);
            setDevelopmentStageObj(prev => {
                return({
                    ...prev,
                    ...obj,
                    ...(draft ?? {}),
                });
            });
        }
        else {
            const draft = takeEditDraft(`DevelopmentStageEdit-${blank_development_stage_obj?.DevelopmentStageId ?? 0}`);
            setDevelopmentStageObj({...blank_development_stage_obj, ...(draft ?? {})});
        }
        setIsLoading(false);
    }, [DevelopmentStageData]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={developmentStageObj?.NeedSave}/>
                    {/* Name Portuguese*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Portuguese")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={developmentStageObj?.DevelopmentStageNamePt}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setDevelopmentStageObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            DevelopmentStageNamePt : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={20}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{developmentStageObj?.DevelopmentStageNamePt?.length} {GetSystemLabel("of")} 20 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* Name English*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("English")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={developmentStageObj?.DevelopmentStageNameEn}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setDevelopmentStageObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            DevelopmentStageNameEn : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={20}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{developmentStageObj?.DevelopmentStageNameEn?.length} {GetSystemLabel("of")} 20 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* Name Spanish*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Spanish")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={developmentStageObj?.DevelopmentStageNameEs}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setDevelopmentStageObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            DevelopmentStageNameEs : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={20}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{developmentStageObj?.DevelopmentStageNameEs?.length} {GetSystemLabel("of")} 20 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>                                        
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* Content Portuguese*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Content")} {GetSystemLabel("Portuguese")}{"*"}
                            </span>
                        </div>
                    </div>  
                    <div className={[Style.py_2].join(" ")}/>
                    <ContentEditor 
                        value={developmentStageObj?.DevelopmentStageDescPt}
                        onChange={(event) => {
                            setDevelopmentStageObj(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    DevelopmentStageDescPt : event,
                                });
                            });
                        }}
                    />

                    <div className={[Style.py_2].join(" ")}/>

                    {/* Content English*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Content")} {GetSystemLabel("English")}
                            </span>
                        </div>
                    </div>
                    <div className={[Style.py_2].join(" ")}/>  
                    <ContentEditor 
                        value={developmentStageObj?.DevelopmentStageDescEn}
                        onChange={(event) => {
                            setDevelopmentStageObj(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    DevelopmentStageDescEn : event,
                                });
                            });
                        }}
                    />
                    
                    <div className={[Style.py_2].join(" ")}/>
                    
                    {/* Content Spanish*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Content")} {GetSystemLabel("Spanish")}
                            </span>
                        </div>
                    </div>  
                    <div className={[Style.py_2].join(" ")}/>
                    <ContentEditor 
                        value={developmentStageObj?.DevelopmentStageDescEs}
                        onChange={(event) => {
                            setDevelopmentStageObj(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    DevelopmentStageDescEs : event,
                                });
                            });
                        }}
                    />

                    <div className={[Style.py_5, Style.border_bottom].join(" ")}/>                            
                    
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((developmentStageObj?.DevelopmentStageId !== null) && (developmentStageObj.DevelopmentStageId !== undefined) && (developmentStageObj.DevelopmentStageId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {developmentStageObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>                              
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );
});
const DevelopmentStageContent       = React.memo(({...setProps}) => {
    const { ContentType,
            StatusList,
            SearchStatus,
            SetSearchStatus,
     }                           = setProps;
    // Mount State                
    const [isReady, setIsReady]                     = useState(false);     
    // Loading State                  
    const [ isLoading,  setIsLoading]               = useState(true);  
    const [rowData,     setRowData]                 = useState([]);   
    const [searchText,  setSearchText]              = useState('');
    const { showSideContent}                        = useSideContent();    
    const { showModal}                              = useModal();

    const fetchDevelopmentStageList = async () => {
        try {
            let payload = await getDevelopmentStageList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const gridContext               = useMemo(() => ({
        isLoading,
        setIsLoading,
        fetchDevelopmentStageList: fetchDevelopmentStageList,
    }), []);

    const columnDefs                = useMemo(() => [
        {
            headerName: GetBusinessLabel("TableHeaderDevelopmentStageData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                           headerName: GetSystemLabel("Edit"),                     field: GetSystemLabel("Edit")                     ,cellRenderer: DevelopmentStageEditBtn, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                { hide: false,lockVisible: true,                           headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Portuguese")}`,                       field: "DevelopmentStageNamePt"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("English")}`,                       field: "DevelopmentStageNameEn"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Spanish")}`,                       field: "DevelopmentStageNameEs"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },         
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "DevelopmentStageId"         ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
            ]
        },
    ].filter(Boolean), []);    

    const NewItem                   = () => {
        const obj_copy = JSON.parse(JSON.stringify(blank_development_stage_obj));
        showSideContent({
            component: DevelopmentStageEdit,
            props: {
                fetchDevelopmentStageList: fetchDevelopmentStageList,
                DevelopmentStageData: obj_copy,
            },
            overlay: true,
        });        
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            fetchDevelopmentStageList();
        }
    }, [ContentType, isReady]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("DevelopmentStagePageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={fetchDevelopmentStageList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>                               
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                         
                        </div>
                    </div>                    
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                gridContext={gridContext}
                            />                     
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
});
//#endregion

export const ContentPage          = () => {
    const [ contentType,    setContentType          ]   = useState(1);
    const [ mount,          setMount                ]   = useState(false);
    const [ statusList,     setStatusList           ]   = useState(null);
    const { showLoader, hideLoader                  }   = useLoader();
    const [ access,         setAccess               ]   = useState(false);
    const [searchStatus, setSearchStatus            ]   = useState({StatusIds: []});    

    const fetchStatusList = async () => {
        try {
            let data = await getSystemStatusList({type: 1});
            if (data) {
                setStatusList(data);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if(!mount) {
            if(ValidateBusinessRules("B")) {
                setAccess(true);
                setMount(true);
                fetchStatusList();
            }
            setMount(true);
        }
    }, [contentType]);


    return (
        access ?
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control].join(" ")}>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(1)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 1) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 1) ? Style.text_decoration_underline   : null, 
                                    (contentType === 1) ? Style.fw_semibold                 : null,
                                    (contentType === 1) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetBusinessLabel("Stages")}
                            </span>
                        </div>                
                    </div>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(2)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 2) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 2) ? Style.text_decoration_underline   : null, 
                                    (contentType === 2) ? Style.fw_semibold                 : null,
                                    (contentType === 2) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetSystemLabel("Content")}
                            </span>
                        </div>                            
                    </div>
                </div>            
            {
                contentType === 1? 
                    <React.Fragment>
                        <DevelopmentStageContent
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}
                        />
                    </React.Fragment>    
                :
                contentType === 2? 
                    <React.Fragment>
                        <AppContentContent
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}
                        />
                    </React.Fragment>                                
                :
                    null
            }
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};